let $ = window.jQuery;
let blogPosts, postGrid, blogPostShare, containerTop, containerBottom, shareHeight, blogDetail;

function onDocumentReady(){
    blogPosts = $('.blog-posts');
    blogDetail = $('.blog-post-content');
    postGrid = blogPosts.find('.grid-item');
    blogPostShare = postGrid.find('.social-share');
    blogPostShare.hover(
        function() {
            $(this).toggleClass('slide-share');
        }
    );
    if(blogDetail && blogDetail.length){
        containerTop = blogDetail.offset().top -20;
        containerBottom = blogDetail.height()+100;
        shareHeight = $('.sticky-share').outerHeight() + 100;
        init();
    }
}

function init() {
    if($(window).width()>=1000){
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if ($('body').hasClass('single')) {
                if (scroll >= containerTop && scroll <= containerBottom - shareHeight) {
                    $('.social-share').addClass('sticky');
                }
                else{
                    $('.social-share').removeClass('sticky');
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/share-controller.js